import {ICommonSaveActionType, ICommonSavePayload, ICommonSearchActionType} from '../Common.actions';
import {createAction} from '@reduxjs/toolkit';
import {ContentItemEdit} from '../../types/requests/ContentItemEdit';
import {ContentItem} from '../../types/models/ContentItem';
import {IError} from '../../@template/helpers/errors';
import {ISearchRequest} from '../../types/common/SearchRequest';
import {ContentItemSearchRequest} from '../../types/requests/ContentItemSearchRequest';
import {PagedEntityListOfContentItemSearchItem} from '../../types/views/PagedEntityListOfContentItemSearchItem';
import {IContentItemSearchItem} from '../../types/views/ContentItemSearchItem';

export const CONTENT_ITEMS: ICommonSaveActionType = {
    SAVE: 'contentItem/save',
    SAVED: 'contentItem/saveSuccess',
    SAVE_ERROR: 'contentItem/saveError',
    LOAD: 'contentItem/load',
    REFRESH: 'contentItem/refresh',
    LOAD_ERROR: 'contentItem/loadError',
    LOADED: 'contentItem/loadSuccess',
}

export interface IContentItemSearchActionTypes extends ICommonSearchActionType {
    SELECT_ITEM: string;
    SET_SELECTION: string;
    CLEAR_SELECTION: string;
}

export const CONTENT_ITEM_SEARCH: IContentItemSearchActionTypes = {
    CHANGE_VIEW: 'contentItemSearch/changeView',
    ERROR: 'contentItemSearch/error',
    LOAD: 'contentItemSearch/load',
    LOADED: 'contentItemSearch/loaded',
    REFRESH: 'contentItemSearch/refresh',
    SELECT_ITEM: 'contentItemSearch/selectItem',
    SET_SELECTION: 'contentItemSearch/setSelection',
    CLEAR_SELECTION: 'contentItemSearch/clearSelect'
}

export const contentItemSave = createAction<ICommonSavePayload<ContentItemEdit>>(CONTENT_ITEMS.SAVE);
export const contentItemSaveSuccess = createAction<ContentItem>(CONTENT_ITEMS.SAVED);
export const contentItemSaveError = createAction<IError>(CONTENT_ITEMS.SAVE_ERROR);
export const contentItemLoad = createAction<string>(CONTENT_ITEMS.LOAD);
export const contentItemRefresh = createAction<string>(CONTENT_ITEMS.REFRESH);
export const contentItemLoadSuccess = createAction<ContentItem>(CONTENT_ITEMS.LOADED);
export const contentItemLoadError = createAction<string>(CONTENT_ITEMS.LOAD_ERROR);
export const contentItemSearch = createAction<ISearchRequest<ContentItemSearchRequest>>(CONTENT_ITEM_SEARCH.LOAD);
export const contentItemSearchSuccess = createAction<PagedEntityListOfContentItemSearchItem>(CONTENT_ITEM_SEARCH.LOADED);
export const contentItemSearchError = createAction<string>(CONTENT_ITEM_SEARCH.ERROR);
export const contentItemSelectSearchItem = createAction<IContentItemSearchItem>(CONTENT_ITEM_SEARCH.SELECT_ITEM);
export const contentItemSetSelection = createAction<IContentItemSearchItem[]>(CONTENT_ITEM_SEARCH.SET_SELECTION);
export const contentItemClearSearchSelection = createAction<void>(CONTENT_ITEM_SEARCH.CLEAR_SELECTION);
